import React, { forwardRef, useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { navigate } from '@reach/router';
import {
  makeStyles,
  Theme,
  Modal,
  Backdrop,
  Fade,
  Divider,
  Typography,
  useTheme,
} from '@material-ui/core';

import { RootState } from 'redux/reducers/type';
import { clearError } from 'redux/actions/actions';

import KeyFlowError from 'commons/framework/KeyFlowError';
import { path } from 'commons/router/routerConfig';

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    // 기존 UI Framework 의 zIndex 를 덮어 쓰지 않아
    // 인라인 스타일로 zIndex 를 지정해 놓음
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '1200px',
    },
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

function ErrorModal() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();

  const { error }: { error: null | KeyFlowError | Error } = useSelector(
    (state: RootState) => state.error,
  );

  const isOpen = useMemo(() => {
    return Boolean(error !== null);
  }, [error]);

  // const onCloseModal = useCallback(() => {
  //   if (error && error.httpStatus === 401) {
  //     navigate(path.LOGIN);
  //   }
  //   dispatch(clearError());
  // }, [dispatch, error]);

  const onCloseModal = useCallback(() => {
    const errorType = typeof error;
    console.log(errorType);
    if (error && (error as KeyFlowError).httpStatus === 401) {
      // if (error && error.httpStatus === 401) {
      navigate(path.LOGIN);
    }
    dispatch(clearError());
  }, [dispatch, error]);


  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      aria-labelledby="error-modal"
      aria-describedby="error-modal"
      className={classes.modal}
      open={isOpen}
      onClose={onCloseModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      style={{ zIndex: theme.zIndex.modal + 1 }}
    >
      <Fade in={isOpen}>
        <div className={classes.paper}>
          <Typography>{error?.message}</Typography>
        </div>
      </Fade>
    </Modal>
  );
}

export default ErrorModal;
